import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const MEETING_ANALYSIS_NAMESPACE_INJECTION_TOKEN$ = 'MEETING_ANALYSIS_NAMESPACE';
export const MEETING_ANALYSIS_ROUTE_PREFIX$ = 'MEETING_ANALYSIS_ROUTE_PREFIX';

export const SALES_COACH_ENABLED_INJECTION_TOKEN$: InjectionToken<Observable<boolean>> = new InjectionToken(
  'sales-coach-enabled',
);
